module.exports = __webpack_public_path__ + "static/img/scan-code2.c024090.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/scan-code2.png
// module id = eAG6
// module chunks = 1